import { render, staticRenderFns } from "./SVGAdminProducts.vue?vue&type=template&id=4daff2ac&scoped=true&"
import script from "./SVGAdminProducts.vue?vue&type=script&lang=js&"
export * from "./SVGAdminProducts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4daff2ac",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/tachyon/facade-configurator/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4daff2ac')) {
      api.createRecord('4daff2ac', component.options)
    } else {
      api.reload('4daff2ac', component.options)
    }
    module.hot.accept("./SVGAdminProducts.vue?vue&type=template&id=4daff2ac&scoped=true&", function () {
      api.rerender('4daff2ac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/UI/SVG/SVGAdminProducts.vue"
export default component.exports